import React from 'react';
import classes from '../InviteUsersModal.module.scss';
import RowLoader from 'components/Sceletons/RowLoader';
import { Button, Collapse, Input } from 'antd';
import Assets from 'assets/icons';
import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { useTranslation } from 'react-i18next';
import { setConfigurableRole } from 'store/slices/dataUsersSlice';
import cn from 'classnames';

type RolesSectionProps = {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
  searchRole: string;
  onSearchRole: (event: React.ChangeEvent<HTMLInputElement>) => void;
  itemsCollapse: any[];
  onChangeCollapse: (keys: string | string[]) => Promise<void>;
};

const RolesSection = ({
  setCurrentSection,
  searchRole,
  onSearchRole,
  itemsCollapse,
  onChangeCollapse,
}: RolesSectionProps) => {
  const { groups } = useAppSelector((state) => state.dataUsers);
  const { userPermissions } = useAppSelector((state) => state.userData);

  const { t } = useTranslation();  
  const dispatch = useAppDispatch();

  const correctHeight = userPermissions?.can_create_group_all_roles
    ? classes.withButton
    : classes.withoutButton;

  const onNewRoleClick = () => {
    dispatch(setConfigurableRole({ id: 'new', name: '', role: {
      id: 'new',
      name: '',
      permissions: []
    }}));
    setCurrentSection('newRole');
  };
  
  return (
    <div className={classes.sectionWrap}>
      <Input
        suffix={<Assets.SearchIcon className={classes.searchIcon} />}
        className={classes.sectionItem}
        allowClear
        value={searchRole}
        onChange={onSearchRole}
        placeholder={t('Users.modals.configureRoles.searchRole')}
      />

      {userPermissions?.can_create_group_all_roles && (
        <Button
          className={classes.sectionItem}
          icon={<PlusOutlined />}
          onClick={onNewRoleClick}
        >
          {t('Users.modals.configureRoles.createNewRole')}
        </Button>
      )}

      <div className={cn(classes.collapseWrap, correctHeight)}>
        {groups[0] 
          ? itemsCollapse?.map(item => (
            <Collapse
              key={item.key}
              className={classes.collapse}
              expandIconPlacement={'end'}
              onChange={onChangeCollapse}
              items={[item]}
            />
          ))
          : [1,2,3].map(el => <RowLoader key={el} width='100%' padding='0 0 0 0' height='46px' />)
        }
      </div>
    </div>
  );
}

export default RolesSection;
